<div class="wrapper">
  <button class="block fill relative" [attr.aria-controls]="expandContainerId" (click)="toggleOpen()">
    <div class="header flex flex--middle">
      <div class="header-icon dn-mobile flex--nogrow flex flex--center ps-small-r">
        <fcom-icon [name]="iconName" [category]="iconCategory" class="is-large" [ngClass]="iconClasses"> </fcom-icon>
      </div>
      <div class="header-content flex flex--align-end align-left">
        <h2
          class="header-title nordic-blue-900-text font-heading-4 ps-small-r"
          [class.capitalize]="capitalizeTitle"
          [attr.aria-describedby]="'subtitle-' + expandContainerId"
        >
          {{ title }}
        </h2>
        <div
          *ngIf="subTitle || subTitleIcon"
          class="header-subtitle-wrapper flex--nogrow flex flex--center"
          [ngClass]="{ 'dn-mobile': !showSubTitleOnMobile }"
        >
          <fcom-icon
            *ngIf="subTitleIcon"
            [name]="subTitleIcon"
            [category]="iconCategory"
            class="ir-xxsmall ps-xxsmall-r"
            [ngClass]="iconClasses"
          >
          </fcom-icon>
          <div
            *ngIf="subTitle"
            class="header-subtitle font-body-1 nordic-blue-900-text"
            [attr.id]="'subtitle-' + expandContainerId"
          >
            {{ subTitle }}
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="!expandOpen && descriptionContent"
      class="passenger-summary nordic-blue-900-text font-body-1 ps-small-r ps-small-t align-left"
      [ngClass]="descriptionClasses"
    >
      <ng-container *ngTemplateOutlet="descriptionContent"></ng-container>
    </div>

    <fcom-icon
      class="chevron-down rotate absolute nordic-blue-900-text"
      name="chevron-down"
      [class.rotate-active]="expandOpen"
    ></fcom-icon>
  </button>

  <fcom-expand
    [ariaId]="expandContainerId"
    class="block"
    [open]="expandOpen"
    [ariaLabelledBy]="'pax-expander-' + expandContainerId"
  >
    <ng-content select="expandedContent"></ng-content>
  </fcom-expand>

  <ng-content select="content"></ng-content>
</div>
